import React, { useRef, useEffect } from "react"
import PropTypes from "prop-types"
import { LottieIcon } from "ksc-portal-common-components/atoms"
import { SET_LOTTIE_FUNCTION } from "../../Sidebar/constants"

const ModuleIcon = ({ dispatch, module, animation, iconName }) => {
  const lottieRef = useRef()

  useEffect(() => {
    if (lottieRef?.current) {
      lottieRef.current.stop()
      dispatch({
        type: SET_LOTTIE_FUNCTION,
        lottieStopFunction: lottieRef.current.stop,
        lottiePlayFunction: lottieRef.current.play,
        iconName,
        module,
      })
    }
  }, [])

  return (
    <LottieIcon
      animation={animation}
      lottieRef={lottieRef}
      width={25}
      height={30}
    />
  )
}

ModuleIcon.propTypes = {
  iconName: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  module: PropTypes.string.isRequired,
  animation: PropTypes.shape({}).isRequired,
}

export default ModuleIcon
